import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { useLanguage } from '../contexts/LanguageContext';
export function ImpressumPage() {
  const {
    language
  } = useLanguage();
  const isEnglish = language === 'en';
  return <div className="min-h-screen bg-[#0a0e1a]" data-id="element-627">
      <Navigation data-id="element-628" />
      <main className="pt-24 pb-16" data-id="element-629">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-630">
          <h1 className="text-4xl font-bold text-white mb-12" data-id="element-631">
            {isEnglish ? 'Legal Notice' : 'Impressum'}
          </h1>

          <div className="prose prose-invert max-w-none" data-id="element-632">
            <section className="mb-8" data-id="element-633">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-634">
                {isEnglish ? 'Address' : 'Adresse'}
              </h2>
              <p className="text-gray-400 leading-relaxed" data-id="element-635">
                CRM Kraft LLC
                <br data-id="element-636" />
                {isEnglish ? 'Represented by: Justus Kraft' : 'Vertreten durch: Justus Kraft'}
                <br data-id="element-637" />
                7901 4th St. N, Ste. 300
                <br data-id="element-638" />
                St. Petersburg, FL 33702
                <br data-id="element-639" />
                United States of America
              </p>
            </section>

            <section className="mb-8" data-id="element-640">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-641">
                {isEnglish ? 'Contact' : 'Kontakt'}
              </h2>
              <p className="text-gray-400 leading-relaxed" data-id="element-642">
                {isEnglish ? 'Phone: +49 157 35999071' : 'Telefon: +49 157 35999071'}
                <br data-id="element-643" />
                {isEnglish ? 'Email: justus@crm-kraft.de' : 'E-Mail: justus@crm-kraft.de'}
              </p>
            </section>

            <section className="mb-8" data-id="element-644">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-645">
                {isEnglish ? 'EU Online Dispute Resolution' : 'EU-Streitschlichtung'}
              </h2>
              <p className="text-gray-400 leading-relaxed" data-id="element-646">
                {isEnglish ? 'The European Commission provides a platform for online dispute resolution (ODR):' : 'Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:'}{' '}
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#ff6b35] hover:underline" data-id="element-647">
                  https://ec.europa.eu/consumers/odr/
                </a>
                .<br data-id="element-648" />
                {isEnglish ? 'You can find our email address above in this Legal Notice.' : 'Unsere E-Mail-Adresse finden Sie oben im Impressum.'}
              </p>
            </section>

            <section data-id="element-649">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-650">
                {isEnglish ? 'Consumer Dispute Resolution' : 'Verbraucherstreitbeilegung/Universalschlichtungsstelle'}
              </h2>
              <p className="text-gray-400 leading-relaxed" data-id="element-651">
                {isEnglish ? 'We are neither willing nor obliged to participate in dispute resolution proceedings before a consumer arbitration board.' : 'Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.'}
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer data-id="element-652" />
    </div>;
}